import { render, staticRenderFns } from "./BeginningPeriodContent.vue?vue&type=template&id=6dc01614&scoped=true&"
import script from "./BeginningPeriodContent.vue?vue&type=script&lang=js&"
export * from "./BeginningPeriodContent.vue?vue&type=script&lang=js&"
import style0 from "./BeginningPeriodContent.vue?vue&type=style&index=0&id=6dc01614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc01614",
  null
  
)

export default component.exports